import { getFocalPointStyles, parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import mergeToNew from "@insite/client-framework/Common/mergeToNew"; // Store Custom Code
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import parseImageUrl from "@insite/client-framework/Common/Utilities/parseImageUrl";
import { responsiveStyleRules } from "@insite/client-framework/Common/Utilities/responsive";
import { useShellContext } from "@insite/client-framework/Components/IsInShell";
import { useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel"; // Store Custom Code
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { useMergeStyles } from "@insite/content-library/additionalStyles";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme"; // Store Custom Code
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer"; // Store Custom Code
import GridItem, { GridItemProps } from "@insite/mobius/GridItem"; // Store Custom Code
import { LinkPresentationProps } from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities"; // Store Custom Code
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS } from "@store/theme/design"; // Store Custom Code
import { buttonBaseStyles } from "@store/theme/mixins"; // Store Custom Code
import onAnchorClick from "@store/utilities/anchorLink"; // Store Custom Code
import * as cssLinter from "css"; // Store Custom Code
import parse from "html-react-parser";
import React, { FC } from "react"; // Store Custom Code
import { css } from "styled-components";

const enum fields {
    background = "background",
    image = "image",
    imageTablet = "imageTablet", // Store Custom Code
    imageMobile = "imageMobile", // Store Custom Code
    hideButton = "hideButton", // Store Custom Code
    focalPoint = "focalPoint",
    backgroundColor = "backgroundColor",
    heading = "heading",
    minimumHeight = "minimumHeight",
    extendMobileWidth = "extendMobileWidth", // Store Custom Code
    desktopRatioHeight = "desktopRatioHeight", // Store Custom Code
    desktopRatioWidth = "desktopRatioWidth", // Store Custom Code
    tabletRatioHeight = "tabletRatioHeight", // Store Custom Code
    tabletRatioWidth = "tabletRatioWidth", // Store Custom Code
    mobileRatioHeight = "mobileRatioHeight", // Store Custom Code
    mobileRatioWidth = "mobileRatioWidth", // Store Custom Code
    subheading = "subheading",
    buttonLabel = "buttonLabel",
    buttonLink = "buttonLink",
    buttonAnchor = "buttonAnchor", // Store Custom Code
    buttonVariant = "variant",
    buttonTwoLabel = "buttonTwoLabel", // Store Custom Code
    buttonTwoLink = "buttonTwoLink", // Store Custom Code
    buttonTwoAnchor = "buttonTwoAnchor", // Store Custom Code
    buttonTwoVariant = "variantTwo", // Store Custom Code
    bannerWidth = "bannerWidth",
    imageOverlay = "imageOverlay",
    partialOverlay = "partialOverlay",
    partialOverlayPositioning = "partialOverlayPositioning",
    disableButton = "disableButton",
    contentPadding = "contentPadding",
    centerTextVertically = "centerTextVertically",
    responsiveFontSizes = "responsiveFontSizes",
    customFontSizes = "customFontSizes",
    h1FontSize = "h1FontSize",
    h2FontSize = "h2FontSize",
    h3FontSize = "h3FontSize",
    h4FontSize = "h4FontSize",
    h5FontSize = "h5FontSize",
    h6FontSize = "h6FontSize",
    normalFontSize = "normalFontSize",
    customCSS = "customCSS",
    columnsLayout = "columnsLayout", // Store Custom Code
    leftBannerColumn = "leftBannerColumn", // Store Custom Code
    rightBannerColumn = "rightBannerColumn", // Store Custom Code
    leftBannerColumnButtonLabel = "leftBannerColumnButtonLabel", // Store Custom Code
    leftBannerColumnButtonLink = "leftBannerColumnButtonLink", // Store Custom Code
    leftBannerColumnAnchorLink = "leftBannerColumnAnchorLink", // Store Custom Code
    rightBannerColumnButtonLabel = "rightBannerColumnButtonLabel", // Store Custom Code
    rightBannerColumnButtonLink = "rightBannerColumnButtonLink", // Store Custom Code
    rightBannerColumnAnchorLink = "rightBannerColumnAnchorLink", // Store Custom Code
    columnsOpacity = "columnsOpacity", // Store Custom Code
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.background]: "image" | "color";
        [fields.image]: string;
        [fields.imageTablet]: string; // Store Custom Code
        [fields.imageMobile]: string; // Store Custom Code
        [fields.hideButton]: boolean; // Store Custom Code
        [fields.focalPoint]:
            | "topLeft"
            | "topCenter"
            | "topRight"
            | "centerLeft"
            | "center"
            | "centerRight"
            | "bottomLeft"
            | "bottomCenter"
            | "bottomRight";
        [fields.backgroundColor]: string;
        [fields.heading]: string;
        [fields.minimumHeight]: "1/4 viewport" | "1/2 viewport" | "3/4 viewport" | "fullViewport" | "manual"; // Store Custom Code
        [fields.extendMobileWidth]: boolean; // Store Custom Code
        [fields.desktopRatioHeight]: number; // Store Custom Code
        [fields.desktopRatioWidth]: number; // Store Custom Code
        [fields.tabletRatioHeight]: number; // Store Custom Code
        [fields.tabletRatioWidth]: number; // Store Custom Code
        [fields.mobileRatioHeight]: number; // Store Custom Code
        [fields.mobileRatioWidth]: number; // Store Custom Code
        [fields.columnsLayout]: boolean; // Store Custom Code
        [fields.leftBannerColumn]: string; // Store Custom Code
        [fields.rightBannerColumn]: string; // Store Custom Code
        [fields.leftBannerColumnButtonLabel]: string; // Store Custom Code
        [fields.leftBannerColumnButtonLink]: LinkFieldValue; // Store Custom Code
        [fields.leftBannerColumnAnchorLink]: string; // Store Custom Code
        [fields.rightBannerColumnButtonLabel]: string; // Store Custom Code
        [fields.rightBannerColumnButtonLink]: LinkFieldValue; // Store Custom Code
        [fields.rightBannerColumnAnchorLink]: string; // Store Custom Code
        [fields.columnsOpacity]: number; // Store Custom Code
        [fields.subheading]: string;
        [fields.buttonLabel]: string;
        [fields.buttonLink]: LinkFieldValue;
        [fields.buttonAnchor]: string; // Store Custom Code
        [fields.buttonVariant]: "primary" | "secondary" | "tertiary";
        [fields.buttonTwoLabel]: string; // Store Custom Code
        [fields.buttonTwoLink]: LinkFieldValue; // Store Custom Code
        [fields.buttonTwoAnchor]: string; // Store Custom Code
        [fields.buttonTwoVariant]: "primary" | "secondary" | "tertiary"; // Store Custom Code
        [fields.imageOverlay]: string;
        [fields.partialOverlay]: boolean;
        [fields.partialOverlayPositioning]: "top" | "middle" | "bottom";
        [fields.disableButton]: boolean;
        [fields.contentPadding]: number;
        [fields.centerTextVertically]: boolean;
        [fields.responsiveFontSizes]: boolean;
        [fields.customFontSizes]: boolean;
        [fields.h1FontSize]: number;
        [fields.h2FontSize]: number;
        [fields.h3FontSize]: number;
        [fields.h4FontSize]: number;
        [fields.h5FontSize]: number;
        [fields.normalFontSize]: number;
        [fields.customCSS]: string;
    };
    extendedStyles?: BannerStyles;
}

export interface BannerStyles {
    wrapper?: InjectableCss;
    overlayWrapper?: InjectableCss;
    buttonsWrapperStyles?: InjectableCss; // Store Custom Code
    /**
     * @deprecated Use the `bannerButton` property instead.
     */
    slideCenteringWrapperStyles?: InjectableCss;
    bannerLink?: LinkPresentationProps;
    bannerButton?: ButtonPresentationProps;
    wrapperStyles?: InjectableCss; // Store Custom Code
    bannerTwoButton?: ButtonPresentationProps; // Store Custom Code
    columns?: GridContainerProps; // Store Custom Code
    column?: GridItemProps; // Store Custom Code
    columnButton?: ButtonPresentationProps; // Store Custom Code
    columnOverlay?: InjectableCss; // Store Custom Code
}

export const bannerStyles: BannerStyles = {
    wrapperStyles: {
        css: css`
            // Store Custom Code
            max-width: none;
        `,
    },
    wrapper: {
        css: css`
            width: 100%;
            display: flex;
        `,
    },
    overlayWrapper: {
        css: css`
            width: 100%;
            color: white;
            text-align: center;
        `,
    },
    bannerTwoButton: {
        variant: "secondary",
        color: "secondary",
        mergeCss: true,
        css: css`
            display: block;
            margin: 0 auto;
            margin-top: 0.75em;
        `,
    },
    // Store Custom Code
    columns: {
        gap: 20,
    },
    column: {
        width: [12, 12, 6, 6, 6],
        css: css`
            ${({ theme }: { theme: BaseTheme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        null,
                        null,
                        css`
                            padding-left: 7%;
                            padding-right: 7%;
                        `,
                    ],
                    "min",
                );
            }}
        `,
    },
    columnButton: {
        css: css`
            margin-left: auto;
            margin-right: auto;
        `,
    },
    columnOverlay: {
        css: css`
            height: 100%;
            width: 100%;
            display: flex;
            justify-content: space-between;
            flex-flow: column;
            border-radius: 0.25em;
            padding: 2rem;
        `,
    },
};

export const Banner: FC<OwnProps> = ({ fields, extendedStyles }) => {
    const history = useHistory();
    const { isInShell } = useShellContext();

    // Store Custom Code
    const { url, title } = useGetLink(fields.buttonLink);
    const { url: url2, title: title2 } = useGetLink(fields.buttonTwoLink || { type: undefined, value: undefined }) || {
        title: undefined,
        url: undefined,
    };
    const { url: leftColumnUrl, title: leftColumnTitle } = useGetLink(
        fields.leftBannerColumnButtonLink || { type: undefined, value: undefined },
    ) || { title: undefined, url: undefined };
    const { url: rightColumnUrl, title: rightColumnTitle } = useGetLink(
        fields.rightBannerColumnButtonLink || { type: undefined, value: undefined },
    ) || { title: undefined, url: undefined };

    // Store Custom Code - Remove backgroundStyle chunk of code
    const focalPointStyles = getFocalPointStyles(fields.focalPoint);

    let minimumHeightStyles;
    switch (fields.minimumHeight) {
        case "1/4 viewport":
            minimumHeightStyles = "min-height: 25vh;";
            break;
        case "1/2 viewport":
            minimumHeightStyles = "min-height: 50vh;";
            break;
        case "3/4 viewport":
            minimumHeightStyles = "min-height: 75vh;";
            break;
        case "fullViewport":
            minimumHeightStyles = "min-height: 100vh;";
            break;
    }

    // Store Custom Code: Change the style declaration so it works with absolute position content
    let overlayPositioningStyles;
    if (!fields.partialOverlay) {
        overlayPositioningStyles = "";
    } else if (fields.partialOverlayPositioning === "top") {
        overlayPositioningStyles = "top: 0;bottom: inherit;";
    } else if (fields.partialOverlayPositioning === "middle") {
        overlayPositioningStyles = "top:inherit;bottom:50%;transform: translateY(50%);";
    } else if (fields.partialOverlayPositioning === "bottom") {
        overlayPositioningStyles = "top:inherit;bottom: 0;";
    }

    const [styles] = React.useState(() => mergeToNew(bannerStyles, extendedStyles));

    let fontSizeStyles;
    if (fields.responsiveFontSizes || fields.customFontSizes) {
        fontSizeStyles = responsiveStyleRules(fields.responsiveFontSizes, fields.customFontSizes ? fields : undefined);
    }

    const customCssWrapper = {
        css: css`
            ${fields.customCSS}
        `,
    };

    // Store Custom Code
    const wrapperStyles = {
        css: css`
            ${styles.wrapper?.css || ""}
            ${focalPointStyles}
            ${fields.minimumHeight !== "manual" ? minimumHeightStyles : ""}
            ${fontSizeStyles}
            background-repeat: no-repeat;  // Store Custom Code
            background-size: cover;  // Store Custom Code
            ${({ theme }: { theme: BaseTheme }) => {
                if (fields.background === "image") {
                    if (fields.imageMobile !== "" && fields.imageTablet !== "") {
                        return breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    background-image: url(${parseImageUrl(fields.imageMobile).url});
                                `,
                                css`
                                    background-image: url(${parseImageUrl(fields.imageTablet).url});
                                `,
                                css`
                                    background-image: url(${parseImageUrl(fields.image).url});
                                `,
                            ],
                            "min",
                        );
                    }
                    return `background-image: url(${parseImageUrl(fields.image).url});`;
                }
                return `background-color: ${fields.backgroundColor};`;
            }}
            ${({ theme }: { theme: BaseTheme }) => {
                if (fields.minimumHeight === "manual") {
                    return breakpointMediaQueries(
                        theme,
                        [
                            css`
                                background-size: cover;
                                padding: ${100 / (fields.mobileRatioWidth / fields.mobileRatioHeight)}% 0 0 0;
                            `,
                            css`
                                padding: ${100 / (fields.tabletRatioWidth / fields.tabletRatioHeight)}% 0 0 0;
                            `,
                            css`
                                padding: ${100 / (fields.desktopRatioWidth / fields.desktopRatioHeight)}% 0 0 0;
                            `,
                        ],
                        "min",
                    );
                }
            }}}
            position: relative;
            cursor: ${fields.hideButton ? "pointer" : "default"};
            &:hover{
                transition: opacity .15s ease-in-out;
                opacity: ${fields.hideButton ? ".8" : "1"};
                ${fields.hideButton ? `outline: 2px solid ${COLORS.primary.base};` : ""}
            }
            ${
                !fields.partialOverlay
                    ? `&:after {
                    content: "";
                    display: block;
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    right: 0;
                    left: 0;
                    background-color: ${fields.background === "image" ? fields.imageOverlay : ""};
                    z-index: 1;
                }`
                    : ""
            }
        `,
    };

    // Store Custom Code: Add option to overflow outside container on mobile
    let wrapperStylesToApply: InjectableCss;
    if (fields.extendMobileWidth) {
        wrapperStylesToApply = {
            css: css`
                ${wrapperStyles.css}
                ${({ theme }: { theme: BaseTheme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            css`
                                width: 105%;
                                margin-left: -2.5%;
                            `,
                            null,
                            null,
                        ],
                        "max",
                    );
                }}
            `,
        };
    } else {
        wrapperStylesToApply = {
            css: css`
                ${wrapperStyles.css}
            `,
        };
    }

    // Store Custom Code
    const columnsBackground = `rgba(0, 0, 0, ${fields.columnsOpacity} / 100 %)`;
    const overlayColor = fields.columnsLayout ? columnsBackground : fields.imageOverlay;

    const overlayWrapperStyles = {
        css: css`
            ${styles.overlayWrapper?.css || ""}
            background-color: ${fields.background === "image" ? overlayColor : ""}; // Store Custom Code
            padding: ${fields.contentPadding}px;
            ${!fields.columnsLayout ? "position: absolute;" : ""} // Store Custom Code
            bottom: 0;
            z-index: 2;
            ${fields.partialOverlay
                ? `
                    ${overlayPositioningStyles}
                    background-color: ${fields.background === "image" ? overlayColor : ""};` // Store Custom Code
                : ""}
            ${fields.centerTextVertically &&
            `bottom:50%;
                transform: translateY(50%);`}
        `,
    };

    // Store Custom Code
    const columnsOverlayStyles = {
        css: css`
            ${styles.columnOverlay?.css || ""}
            background: rgba(0, 0, 0, ${fields.columnsOpacity / 100});
        `,
    };

    // Store Custom Code
    const columnsStyles = {
        gap: styles.columns?.gap,
        css: css`
            max-width: none !important;
            ${GridOffset} {
                ${fields.leftBannerColumn && !fields.rightBannerColumn && `justify-content: flex-start;`}
                ${!fields.leftBannerColumn && fields.rightBannerColumn && `justify-content: flex-end;`}
            }
        `,
    };

    // Store Custom Code
    interface ColumnProps {
        content: string;
        label: string;
        link: string | undefined;
        anchor: string | undefined;
    }

    // Store Custom Code
    const Column: React.FC<ColumnProps> = ({ content, label, link, anchor }) => {
        return (
            <GridItem {...styles.column}>
                <StyledWrapper {...columnsOverlayStyles}>
                    <>{parse(content, parserOptions)}</>
                    {label && (
                        <Button
                            {...styles.columnButton}
                            variant="primary"
                            onClick={() => onAnchorClick(history, isInShell, link, `#${anchor}`)}
                        >
                            {label}
                        </Button>
                    )}
                </StyledWrapper>
            </GridItem>
        );
    };

    // Store Custom Code
    return (
        <StyledWrapper {...customCssWrapper}>
            <StyledWrapper
                className="banner-wrapper"
                {...wrapperStylesToApply}
                onClick={() => {
                    // Store Custom Code
                    if (fields.hideButton && !fields.columnsLayout) {
                        return onAnchorClick(history, isInShell, fields.buttonAnchor, fields.buttonLink);
                    }
                }}
            >
                <StyledWrapper className="banner-overlay-wrapper" {...overlayWrapperStyles}>
                    <StyledWrapper className="banner-center-wrapper" {...styles.wrapperStyles}>
                        {!fields.columnsLayout && (
                            <>
                                <Typography className="banner-heading">
                                    {parse(fields.heading, parserOptions)}
                                </Typography>
                                <Typography className="banner-subheading">
                                    {parse(fields.subheading, parserOptions)}
                                </Typography>
                                <StyledWrapper {...styles.buttonsWrapperStyles}>
                                    {!fields.hideButton && !fields.disableButton && (
                                        <Button
                                            {...styles.bannerButton}
                                            variant={fields.variant}
                                            // Store Custom Code
                                            onClick={() =>
                                                onAnchorClick(history, isInShell, `#${fields.buttonAnchor}`, url)
                                            }
                                        >
                                            {fields.buttonLabel}
                                        </Button>
                                    )}
                                    {fields.buttonTwoLabel && fields.buttonTwoLabel && !fields.disableButton && (
                                        <Button
                                            {...styles.bannerTwoButton}
                                            variant={fields.variant}
                                            // Store Custom Code
                                            onClick={() =>
                                                onAnchorClick(history, isInShell, `#${fields.buttonTwoAnchor}`, url2)
                                            }
                                        >
                                            {fields.buttonTwoLabel}
                                        </Button>
                                    )}
                                </StyledWrapper>
                            </>
                        )}
                        {fields.columnsLayout && ( // Store Custom Code
                            <GridContainer {...columnsStyles}>
                                {fields.leftBannerColumn && (
                                    <Column
                                        content={fields.leftBannerColumn}
                                        label={fields.leftBannerColumnButtonLabel}
                                        link={leftColumnUrl}
                                        anchor={fields.leftBannerColumnAnchorLink}
                                    />
                                )}
                                {fields.rightBannerColumn && (
                                    <Column
                                        content={fields.rightBannerColumn}
                                        label={fields.rightBannerColumnButtonLabel}
                                        link={rightColumnUrl}
                                        anchor={fields.rightBannerColumnAnchorLink}
                                    />
                                )}
                            </GridContainer>
                        )}
                    </StyledWrapper>
                </StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const defaultCustomCss = `.banner-wrapper {
}

.banner-overlay-wrapper {
}

.banner-center-wrapper {
}

.banner-heading {
}

.banner-subheading {
}
`;

const basicTab = {
    displayName: "Basic",
    sortOrder: 0,
};

const settingsTab = {
    displayName: "Settings",
    sortOrder: 1,
};

const advancedTab = {
    displayName: "Advanced",
    sortOrder: 2,
};

// Store Custom Code
const columnsTab = {
    displayName: "Columns",
    sortOrder: 3,
};

const banner: WidgetModule = {
    component: Banner,
    definition: {
        group: "Basic",
        icon: "image-landscape",
        fieldDefinitions: [
            {
                fieldType: "Contextual",
                name: fields.background,
                displayName: "Background",
                editorTemplate: "DropDownField",
                options: [
                    { displayName: "Image", value: "image" },
                    { displayName: "Color", value: "color" },
                ],
                defaultValue: "image",
                hideEmptyOption: true,
                tab: basicTab,
            },
            // Store Custom Code
            {
                fieldType: "Contextual",
                name: fields.image,
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                isVisible: widget => widget.fields.background === "image",
                tooltip: "If tablet and mobile images are not used, this image is displayed for all sizes.",
                tab: basicTab,
            },
            // Store Custom Code
            {
                fieldType: "Contextual",
                name: fields.imageTablet,
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                isVisible: widget => widget.fields.background === "image",
                tab: basicTab,
            },
            // Store Custom Code
            {
                fieldType: "Contextual",
                name: fields.imageMobile,
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                isVisible: widget => widget.fields.background === "image",
                tab: basicTab,
            },
            // Store Custom Code
            {
                fieldType: "Contextual",
                name: fields.hideButton,
                editorTemplate: "CheckboxField",
                tooltip: "Make all image clickable",
                defaultValue: false,
                tab: basicTab,
            },
            {
                fieldType: "Contextual",
                name: fields.imageOverlay,
                displayName: "Image Color Overlay",
                editorTemplate: "ColorPickerField",
                defaultValue: "",
                isVisible: widget => widget.fields.background === "image",
                tab: basicTab,
            },
            {
                fieldType: "Contextual",
                name: fields.partialOverlay,
                editorTemplate: "CheckboxField",
                defaultValue: false,
                tab: basicTab,
            },
            {
                fieldType: "Contextual",
                name: fields.partialOverlayPositioning,
                editorTemplate: "DropDownField",
                options: [
                    { displayName: "Top", value: "top" },
                    { displayName: "Middle", value: "middle" },
                    { displayName: "Bottom", value: "bottom" },
                ],
                hideEmptyOption: true,
                defaultValue: "bottom",
                isVisible: widget => widget.fields.partialOverlay,
                tab: basicTab,
            },
            {
                fieldType: "Contextual",
                name: fields.focalPoint,
                displayName: "Focal Point",
                editorTemplate: "DropDownField",
                options: [
                    { displayName: "Top Left", value: "topLeft" },
                    { displayName: "Top Center", value: "topCenter" },
                    { displayName: "Top Right", value: "topRight" },
                    { displayName: "Center Left", value: "centerLeft" },
                    { displayName: "Center", value: "center" },
                    { displayName: "Center Right", value: "centerRight" },
                    { displayName: "Bottom Left", value: "bottomLeft" },
                    { displayName: "Bottom Center", value: "bottomCenter" },
                    { displayName: "Bottom Right", value: "bottomRight" },
                ],
                defaultValue: "center",
                hideEmptyOption: true,
                isVisible: widget => widget.fields.background === "image",
                tab: basicTab,
            },
            {
                fieldType: "Contextual",
                name: fields.backgroundColor,
                editorTemplate: "ColorPickerField",
                displayName: "Color",
                defaultValue: "black",
                isVisible: widget => widget.fields.background === "color",
                tab: basicTab,
            },
            {
                fieldType: "Contextual",
                name: fields.heading,
                editorTemplate: "RichTextField",
                displayName: "Heading",
                defaultValue: "",
                extendedConfig: { height: 100 },
                expandedToolbarButtons: {
                    moreMisc: {},
                    code: {},
                },
                tab: basicTab,
            },
            {
                fieldType: "Contextual",
                name: fields.subheading,
                editorTemplate: "RichTextField",
                displayName: "Subheading",
                defaultValue: "",
                extendedConfig: { height: 170 },
                expandedToolbarButtons: {
                    moreMisc: {},
                    code: {},
                },
                tab: basicTab,
            },
            {
                fieldType: "Contextual",
                name: fields.buttonLabel,
                editorTemplate: "TextField",
                displayName: "Button Label",
                defaultValue: "",
                tab: basicTab,
            },
            {
                fieldType: "Contextual",
                name: fields.buttonLink,
                displayName: "Button Link",
                editorTemplate: "LinkField",
                defaultValue: { type: "Page", value: "" },
                tab: basicTab,
            },
            {
                // Store Custom Code
                fieldType: "Contextual",
                name: fields.buttonAnchor,
                displayName: "Button Anchor Link",
                editorTemplate: "TextField",
                defaultValue: "",
                tab: basicTab,
                tooltip: "Overrides Button Link. # symbol will be prepended automaticaly.",
            },
            {
                name: fields.buttonVariant,
                displayName: "Button Variant",
                editorTemplate: "DropDownField",
                options: [
                    { displayName: "Primary", value: "primary" },
                    { displayName: "Secondary", value: "secondary" },
                    { displayName: "Tertiary", value: "tertiary" },
                ],
                hideEmptyOption: true,
                defaultValue: "primary",
                fieldType: "Contextual",
                tab: basicTab,
            },
            {
                fieldType: "Contextual",
                name: fields.buttonTwoLabel,
                editorTemplate: "TextField",
                displayName: "Button 2 Label",
                defaultValue: "",
                tab: basicTab,
            },
            {
                fieldType: "Contextual",
                name: fields.buttonTwoLink,
                displayName: "Button 2 Link",
                editorTemplate: "LinkField",
                defaultValue: { type: "Page", value: "" },
                tab: basicTab,
            },
            {
                // Store Custom Code
                fieldType: "Contextual",
                name: fields.buttonTwoAnchor,
                displayName: "Button Two Anchor Link",
                editorTemplate: "TextField",
                defaultValue: "",
                tab: basicTab,
                tooltip: "Overrides Button 2 Link. # symbol will be prepended automaticaly.",
            },
            {
                name: fields.buttonTwoVariant,
                displayName: "Button 2 Variant",
                editorTemplate: "DropDownField",
                options: [
                    { displayName: "Primary", value: "primary" },
                    { displayName: "Secondary", value: "secondary" },
                    { displayName: "Tertiary", value: "tertiary" },
                ],
                hideEmptyOption: true,
                defaultValue: "primary",
                fieldType: "Contextual",
                tab: basicTab,
            },
            {
                fieldType: "Contextual",
                name: fields.minimumHeight,
                displayName: "Minimum Banner Height",
                editorTemplate: "DropDownField",
                options: [
                    { displayName: "1/4 Viewport", value: "1/4 viewport" },
                    { displayName: "1/2 Viewport", value: "1/2 viewport" },
                    { displayName: "3/4 Viewport", value: "3/4 viewport" },
                    { displayName: "Full Viewport", value: "fullViewport" },
                    { displayName: "Manual", value: "manual" },
                ],
                defaultValue: "1/4 viewport",
                hideEmptyOption: true,
                tab: basicTab,
            },
            // Store Custom Code
            {
                name: "desktopRatioWidth",
                editorTemplate: "IntegerField",
                min: 1,
                defaultValue: 47,
                fieldType: "Contextual",
                tab: basicTab,
                isVisible: (item?: HasFields) => {
                    return item?.fields.minimumHeight === "manual";
                },
            },
            {
                name: "desktopRatioHeight",
                editorTemplate: "IntegerField",
                min: 1,
                defaultValue: 13,
                fieldType: "Contextual",
                tab: basicTab,
                isVisible: (item?: HasFields) => {
                    return item?.fields.minimumHeight === "manual";
                },
            },
            {
                name: "tabletRatioWidth",
                editorTemplate: "IntegerField",
                min: 1,
                defaultValue: 43,
                fieldType: "Contextual",
                tab: basicTab,
                isVisible: (item?: HasFields) => {
                    return item?.fields.minimumHeight === "manual";
                },
            },
            {
                name: "tabletRatioHeight",
                editorTemplate: "IntegerField",
                min: 1,
                defaultValue: 50,
                fieldType: "Contextual",
                tab: basicTab,
                isVisible: (item?: HasFields) => {
                    return item?.fields.minimumHeight === "manual";
                },
            },
            {
                name: "mobileRatioWidth",
                editorTemplate: "IntegerField",
                min: 1,
                defaultValue: 43,
                fieldType: "Contextual",
                tab: basicTab,
                isVisible: (item?: HasFields) => {
                    return item?.fields.minimumHeight === "manual";
                },
            },
            {
                name: "mobileRatioHeight",
                editorTemplate: "IntegerField",
                min: 1,
                defaultValue: 50,
                fieldType: "Contextual",
                tab: basicTab,
                isVisible: (item?: HasFields) => {
                    return item?.fields.minimumHeight === "manual";
                },
            },
            {
                name: fields.extendMobileWidth,
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
                tab: basicTab,
            },
            {
                fieldType: "Contextual",
                name: fields.disableButton,
                editorTemplate: "CheckboxField",
                defaultValue: false,
                tab: basicTab,
            },
            {
                name: fields.responsiveFontSizes,
                editorTemplate: "CheckboxField",
                fieldType: "Contextual",
                tab: settingsTab,
                defaultValue: true,
            },
            {
                fieldType: "Contextual",
                name: fields.contentPadding,
                editorTemplate: "IntegerField",
                defaultValue: 50,
                tab: basicTab,
            },
            {
                fieldType: "Contextual",
                name: "centerTextVertically",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                tab: basicTab,
            },
            {
                name: fields.customFontSizes,
                editorTemplate: "CheckboxField",
                fieldType: "Contextual",
                tab: settingsTab,
                defaultValue: false,
            },
            {
                name: fields.normalFontSize,
                editorTemplate: "IntegerField",
                fieldType: "Contextual",
                tab: settingsTab,
                min: 1,
                defaultValue: null,
                isVisible: item => item?.fields[fields.customFontSizes],
            },
            {
                name: fields.h1FontSize,
                editorTemplate: "IntegerField",
                fieldType: "Contextual",
                tab: settingsTab,
                min: 1,
                defaultValue: 40,
                isVisible: item => item?.fields[fields.customFontSizes],
            },
            {
                name: fields.h2FontSize,
                editorTemplate: "IntegerField",
                fieldType: "Contextual",
                tab: settingsTab,
                min: 1,
                defaultValue: 32,
                isVisible: item => item?.fields[fields.customFontSizes],
            },
            {
                name: fields.h3FontSize,
                editorTemplate: "IntegerField",
                fieldType: "Contextual",
                tab: settingsTab,
                min: 1,
                defaultValue: null,
                isVisible: item => item?.fields[fields.customFontSizes],
            },
            {
                name: fields.h4FontSize,
                editorTemplate: "IntegerField",
                fieldType: "Contextual",
                tab: settingsTab,
                min: 1,
                defaultValue: null,
                isVisible: item => item?.fields[fields.customFontSizes],
            },
            {
                name: fields.h5FontSize,
                editorTemplate: "IntegerField",
                fieldType: "Contextual",
                tab: settingsTab,
                min: 1,
                defaultValue: null,
                isVisible: item => item?.fields[fields.customFontSizes],
            },
            {
                name: fields.h6FontSize,
                editorTemplate: "IntegerField",
                fieldType: "Contextual",
                tab: settingsTab,
                min: 1,
                defaultValue: null,
                isVisible: item => item?.fields[fields.customFontSizes],
            },
            {
                name: fields.customCSS,
                displayName: "Custom CSS",
                editorTemplate: "CodeField",
                fieldType: "Contextual",
                tab: advancedTab,
                defaultValue: defaultCustomCss,
                isVisible: (item, shouldDisplayAdvancedFeatures) => !!shouldDisplayAdvancedFeatures,
                validate: value => {
                    if (value === undefined || value === null) {
                        return "";
                    }

                    const result = cssLinter.parse(value, { silent: true });
                    if (result?.stylesheet?.parsingErrors) {
                        // the error output at this time only has room for one line so we just show the first error
                        return result.stylesheet.parsingErrors.length <= 0
                            ? ""
                            : result.stylesheet.parsingErrors.map(error => `${error.reason} on line ${error.line}`)[0];
                    }

                    return "Unable to parse Css";
                },
                options: {
                    mode: "css",
                    lint: true,
                    autoRefresh: true,
                },
            },
            // Store Custom Code
            {
                fieldType: "Contextual",
                name: fields.columnsLayout,
                displayName: "Columns Overlay",
                editorTemplate: "CheckboxField",
                tooltip: "Use alternative two column layout overlay",
                defaultValue: false,
                tab: columnsTab,
            },
            {
                fieldType: "Contextual",
                name: fields.columnsOpacity,
                displayName: "Columns Overlay Opacity",
                editorTemplate: "IntegerField",
                min: 0,
                max: 100,
                defaultValue: 50,
                tab: columnsTab,
                isVisible: item => item?.fields[fields.columnsLayout],
            },
            {
                fieldType: "Contextual",
                name: fields.leftBannerColumn,
                editorTemplate: "RichTextField",
                displayName: "Left Banner Column Content",
                defaultValue: "",
                extendedConfig: { height: 170 },
                expandedToolbarButtons: {
                    moreMisc: {},
                    code: {},
                },
                tab: columnsTab,
                isVisible: item => item?.fields[fields.columnsLayout],
            },
            {
                fieldType: "Contextual",
                name: fields.rightBannerColumn,
                editorTemplate: "RichTextField",
                displayName: "Right Banner Column Content",
                defaultValue: "",
                extendedConfig: { height: 170 },
                expandedToolbarButtons: {
                    moreMisc: {},
                    code: {},
                },
                tab: columnsTab,
                isVisible: item => item?.fields[fields.columnsLayout],
            },
            {
                fieldType: "Contextual",
                name: fields.leftBannerColumnButtonLabel,
                editorTemplate: "TextField",
                displayName: "Left Banner Column Button Label",
                defaultValue: "",
                tab: columnsTab,
                isVisible: item => item?.fields[fields.columnsLayout],
            },
            {
                fieldType: "Contextual",
                name: fields.leftBannerColumnButtonLink,
                displayName: "Left Banner Column Button Link",
                editorTemplate: "LinkField",
                defaultValue: { type: "Page", value: "" },
                tab: columnsTab,
                isVisible: item => item?.fields[fields.columnsLayout],
            },
            {
                fieldType: "Contextual",
                name: fields.leftBannerColumnAnchorLink,
                displayName: "Left Banner Column Anchor Link",
                editorTemplate: "TextField",
                defaultValue: "",
                tab: columnsTab,
                tooltip: "Overrides Left Banner Column Button Link. # symbol will be prepended automaticaly.",
                isVisible: item => item?.fields[fields.columnsLayout],
            },
            {
                fieldType: "Contextual",
                name: fields.rightBannerColumnButtonLabel,
                editorTemplate: "TextField",
                displayName: "Right Banner Column Button Label",
                defaultValue: "",
                tab: columnsTab,
                isVisible: item => item?.fields[fields.columnsLayout],
            },
            {
                fieldType: "Contextual",
                name: fields.rightBannerColumnButtonLink,
                displayName: "Right Banner Column Button Link",
                editorTemplate: "LinkField",
                defaultValue: { type: "Page", value: "" },
                tab: columnsTab,
                isVisible: item => item?.fields[fields.columnsLayout],
            },
            {
                fieldType: "Contextual",
                name: fields.rightBannerColumnAnchorLink,
                displayName: "Right Banner Column Anchor Link",
                editorTemplate: "TextField",
                defaultValue: "",
                tab: columnsTab,
                tooltip: "Overrides Right Banner Column Button Link. # symbol will be prepended automaticaly.",
                isVisible: item => item?.fields[fields.columnsLayout],
            },
        ],
    },
};

export default banner;
